export const styles = () => ({
  coachModal: {
    height: "29em",
    maxWidth: "40em",
    width: "90%",
    borderRadius:"8px"
  },
  inputs: {
    width: "100%",
  },
  lightWarning: {
    color: "orange",
  },
  warning: {
    color: "red",
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/edit-coach-modal/styles.ts